import React from 'react';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import fr from 'facet-rest';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import Button from 'Components/UI/Button';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import RichTextDisplay from 'Components/UI/Overrides/RichTextDisplay';

export const metaOverrideSet = fr.metaOverride()
  .overrideAll({
    _hideLabel: true,
  }, { ordinal: 200 })
  .nameOverride('question', {
    _component: () => Text,
    _customProps: {
      variant: 'h5',
      weight: 'bold',
      color: 'black',
      align: 'left',
    },
  }, { ordinal: 201 })
  .nameOverride('answer', {
    _component: () => RichTextDisplay,
    _customProps: {
      variant: 'h6',
      color: 'darkGray',
      weight: 'light',
      align: 'left',
    },
  }, { ordinal: 201 });


export default function FAQQuestion() {
  const { resource } = useMetaLayoutContext();

  return <>
    <Box marginBottom={3}>
      <Box marginBottom={2}><MetaControlField attr="question" /></Box>
      <Box marginBottom={1}><MetaControlField attr="answer" /></Box>
      {!!resource.relationship(fr.relationships.externalLink.name) && (
        <a href={resource.relationship(fr.relationships.externalLink.name).link('related').url()} target={'_blank'}>
          <Button
            startIcon={<OpenInNewIcon />}
            variant={'text'}
            color={'primary'}
          >
            {resource.relationship(fr.relationships.externalLink.name).meta('label')}
          </Button>
        </a>
      )}
    </Box>
  </>;
}
